/* import __COLOCATED_TEMPLATE__ from './performance-overview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();